// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__-2DD2","sidebar":"Home_sidebar__JcUG7","main":"Home_main__Nos0v","sticky":"Home_sticky__tpPay","mainWrapper":"Home_mainWrapper__vLwqW"};